<template>
  <fts-dropdown-select ref="dropdown" class="image-variation-dropdown" content-class="image-variation-dropdown-menu"
    :offset="[0, 6]" @show="openDropdown" @hide="confirmSelection">
    <template #toggle>
      <slot name="toggle" />
    </template>

    <template #menu>
      <div class="font-control">
        <div class="font-weights">
          <div :class="{ selected: ratio === '1:1' }" @click="toggleRatio('1:1')">1:1</div>
          <div :class="{ selected: ratio === '3:2' }" @click="toggleRatio('3:2')">3:2</div>
          <div :class="{ selected: !ratio }" @click="toggleRatio(null)">3:4</div>
          <div :class="{ selected: ratio === '16:9' }" @click="toggleRatio('16:9')">16:9</div>
        </div>
        <div class="divider"></div>
        <div class="font-sizes">
          <div :class="{ selected: orientation === 'portrait' }" @click="toggleOrientation('portrait')">Portrait</div>
          <div :class="{ selected: !orientation }" @click="toggleOrientation(null)">Landscape</div>
        </div>
      </div>
    </template>
  </fts-dropdown-select>
</template>


<script>

import FTSToggleSwitch from '../elements/FTSToggleSwitch';
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSLabelGroup from '../elements/FTSLabelGroup';
import FTSCheckbox from '../elements/FTSCheckbox';

export default {
  name: 'ImageVariationDropdown',
  components: {
    'fts-toggle-switch': FTSToggleSwitch,
    "fts-dropdown-select": FTSDropdownSelect,
    'fts-label-group': FTSLabelGroup,
    "fts-checkbox": FTSCheckbox,
  },
  emits: ['select'],
  props: {
    initialVariation: Object,
  },
  data() {
    return {
      ratio: null, // 1:1, 3:2, 4:3, 16:9
      orientation: null, // portrait, landscape
    }
  },
  methods: {
    openDropdown() {
      this.ratio = this.initialVariation.ratio;
      this.orientation = this.initialVariation.orientation;
    },
    toggleRatio(v) {
      this.ratio = v;
    },
    toggleOrientation(v) {
      this.orientation = v;
    },
    confirmSelection() {
      this.$emit('select', {
        ...(this.ratio != null && { ratio: this.ratio }),
        ...(this.orientation != null && { orientation: this.orientation })
      });
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.font-control {
  width: 200px;
  display: flex;
  flex-direction: column;
  color: var(--fts-text);

  .font-weights,
  .font-sizes {
    display: flex;
    justify-content: space-between;
    text-align: center;

    >div {
      flex: 1;
      padding: 4px 8px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        background-color: #f0f0f0;
      }

      &.selected {
        color: var(--fts-primary);
      }
    }
  }

  .divider {
    height: 1px;
    background-color: var(--fts-border);
    margin: 4px;
  }

}
</style>
